function getPageRange(currentPage, totalPages) {
  if (totalPages < 1) return []

  const page = Math.min(Math.max(currentPage, 1), totalPages)
  const start = Math.floor((page - 1) / 10) * 10 + 1

  return Array.from({ length: Math.min(10, totalPages - start + 1) }, (_, index) => start + index)
}

module.exports = { getPageRange }
